(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionnaireTemplateSectionListEditController', Controller);

    Controller.$inject = ['$scope', 'notificationService', 'oddQuestionnaireTemplateService'];

    function Controller($scope, notificationService, oddQuestionnaireTemplateService) {
        var boxModelClone = angular.copy($scope.boxModel);
        var questionnaire = $scope.boxContext.questionnaireTemplate;

        $scope.remove = remove;
        $scope.moveTo = moveTo;

        $scope.ctrlCtxt = {};
        $scope.sortableOptions = {
            animation: 0,
            forceFallback: true,
            disabled: questionnaire.IsInCampaign,
            scroll: true,
            scrollSpeed: 20,
            scrollSensitivity: 30,
            onUpdate: onSortUpdate,
            handle: '.sortable-handle'
        };

        function remove(item) {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.deleteSection(item.ODDBusinessUnitID, item.ODDQuestionnaireID,
                    item.ODDSectionID).then(function () {

                notificationService.notify('Section has been deleted');

                _.pull($scope.boxModel, item);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }

        function moveTo(item, direction) {
            _.pull($scope.boxModel, item);

            if (direction === 'top') {
                $scope.boxModel.unshift(item);
            } else {
                $scope.boxModel.push(item);
            }

            onSortUpdate();
        }

        function onSortUpdate() {
            $scope.ctrlCtxt.isLoading = true;
            
            return oddQuestionnaireTemplateService.orderSections(
                    $scope.boxModel[0].ODDBusinessUnitID,
                    $scope.boxModel[0].ODDQuestionnaireID,
                    $scope.boxModel)
                .then(function() {
                    notificationService.notify('Sections have been reordered');
                    boxModelClone = angular.copy($scope.boxModel);
                })
                .catch(function() {
                    $scope.boxModel = angular.copy(boxModelClone);
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        }
    }

})();